import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> HIPAA </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>HIPAA Compliance</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  The Health Insurance Portability and Accountability Act (HIPAA) sets the national standard for safeguarding protected health information (PHI) in the United States. Any organization handling patient data — including healthcare providers, insurers, and business associates — must comply with HIPAA to ensure confidentiality, integrity, and availability of sensitive medical data. Our HIPAA Compliance services help organizations achieve and maintain compliance through risk assessments, security safeguards, policy development, and continuous monitoring — enabling you to protect patient trust while avoiding costly penalties.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  { icon: "fa-arrows-down-to-people", title: "Patient Trust", desc: "Protects the confidentiality of personal health data." },
                  { icon: "fa-database", title: "Legal Obligation", desc: "Non-compliance can lead to fines up to $1.5M per violation and civil lawsuits." },
                  { icon: "fa-shield-halved", title: "Data Security", desc: "Reduces risk of breaches, ransomware attacks, and unauthorized disclosures." },
                  { icon: "fa-table", title: "Healthcare Reputation", desc: "Builds credibility with patients, insurers, and partners." },
                  { icon: "fa-business-time", title: "Business Advantage", desc: "HIPAA-compliant organizations gain stronger contracts and partnerships in healthcare and related industries." },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content" id="ex2-content">
                    {/* Methodology */}
                    <div className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`} role="tabpanel">
                      <p>Our HIPAA Compliance framework ensures a structured, risk-based approach:</p>
                      <ul>
                        <li><b>Gap & Risk Assessment :-</b> Evaluate your current controls against HIPAA Privacy, Security, and Breach Notification Rules.</li>
                        <li><b>Data Flow & Asset Mapping :-</b> Identify where PHI is stored, processed, and transmitted.</li>
                        <li><b>Administrative Safeguards :-</b> Develop governance policies, workforce training, and access management.</li>
                        <li><b>Technical Safeguards :-</b> Implement encryption, multi-factor authentication, audit logs, and monitoring.</li>
                        <li><b>Physical Safeguards :-</b> Secure facilities, servers, and endpoint devices.</li>
                        <li><b>Policy & Documentation :-</b> Create HIPAA-aligned policies, incident response, and breach reporting protocols.</li>
                        <li><b>Validation & Audit Support :-</b> Prepare documentation and evidence for internal or external HIPAA audits.</li>
                        <li><b>Continuous Compliance :-</b> Provide ongoing monitoring, training, and advisory.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`} role="tabpanel">
                      <ul>
                        <li>Avoid fines, penalties, and lawsuits related to non-compliance.</li>
                        <li>Strengthen patient trust and confidence in your services.</li>
                        <li>Reduce risk of breaches and cyberattacks targeting PHI.</li>
                        <li>Ensure compliance with HIPAA Privacy, Security & Breach Notification Rules.</li>
                        <li>Build stronger relationships with insurers, partners, and regulators.</li>
                        <li>Enhance your competitive advantage in the healthcare sector.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`} role="tabpanel">
                      <p>Our HIPAA Compliance service provides:</p>
                      <ul>
                        <li><b>HIPAA Gap Assessment Report :-</b> Detailed findings against HIPAA requirements.</li>
                        <li><b>Risk Assessment & Remediation Plan :-</b> Prioritized roadmap for compliance.</li>
                        <li><b>Policies & Procedures Documentation :-</b> Customized for your organization.</li>
                        <li><b>Technical Safeguards Implementation Guidance :-</b> Encryption, access controls, and audit logging.</li>
                        <li><b>Workforce Training Modules :-</b> Educating staff on HIPAA rules and responsibilities.</li>
                        <li><b>Audit-Ready Evidence Package :-</b> Documentation for regulators and auditors.</li>
                        <li><b>Ongoing Compliance Monitoring & Advisory :-</b> Continuous support for staying compliant.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li><b>Healthcare-Centric Expertise :-</b> Deep understanding of HIPAA, HITECH, and healthcare compliance frameworks.</li>
                    <li><b>End-to-End Support :-</b> From initial assessment to full HIPAA audit preparation.</li>
                    <li><b>Practical & Scalable :-</b> We design compliance strategies tailored to your organization size and complexity.</li>
                    <li><b>Security + Compliance Focus :-</b> Beyond documentation, we ensure your PHI environment is truly secure.</li>
                    <li><b>Experience Across Healthcare Ecosystem :-</b> Hospitals, insurers, clinics, SaaS healthcare platforms, and business associates.</li>
                    <li><b>Continuous Advisory :-</b> Compliance is not one-time — we provide ongoing support for sustainable HIPAA programs.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;